export const ADD_ASSET = 'ADD_ASSET';
export const ADD_ASSET_NOTE = 'ADD_ASSETS_NOTE';
export const ADD_ASSETS_FILES = 'ADD_ASSETS_FILES';
export const CALCULATE_ASSET_DEPRECIATION = 'CALCULATE_ASSET_DEPRECIATION';
export const DISABLE_ASSET = 'DISABLE_ASSET';
export const ENABLE_ASSET = 'ENABLE_ASSET';
export const GET_ASSET_BY_ID = 'GET_ASSET_BY_ID';
export const GET_ASSETS = 'GET_ASSETS';
export const GET_ASSETS_CSV = 'GET_ASSETS_CSV';
export const GET_ASSETS_XLSX = 'GET_ASSETS_XLSX'; // @author Jorge Casas
export const GET_ASSETS_DISABLE_FORM_CONFIG = 'GET_ASSETS_DISABLE_FORM_CONFIG';
export const GET_ASSETS_FORM_CONFIG = 'GET_ASSETS_FORM_CONFIG';
export const MODIFY_ASSET = 'MODIFY_ASSET';
export const MODIFY_ASSET_NOTE = 'MODIFY_ASSET_NOTE';
export const NEW_ASSET = 'NEW_ASSET';
export const PROGRESS_ASSETS_FILE = 'PROGRESS_ASSETS_FILE';
export const REMOVE_ASSET_NOTE = 'REMOVE_ASSET_NOTE';
export const REMOVE_ASSETS_FILE = 'REMOVE_ASSETS_FILE';
export const REMOVE_ASSETS_UPLOADED_FILE = 'REMOVE_ASSETS_UPLOADED_FILE';
export const RESET_ASSETS_FORM = 'RESET_ASSETS_FORM';
export const RESET_ASSETS_LIST = 'RESET_ASSETS_LIST';
export const SET_ASSETS_FILTERS = 'SET_ASSETS_FILTERS';
export const SET_ASSETS_IS_SAVING = 'SET_ASSETS_IS_SAVING';
export const SET_ASSETS_PAGINATION = 'SET_ASSETS_PAGINATION';
export const SET_SELECTED_ASSET = 'SET_SELECTED_ASSET';
export const SET_ENABLE_ASSET_MODAL_IS_OPEN = 'SET_ENABLE_ASSET_MODAL_IS_OPEN';
export const UPDATE_ASSET = 'UPDATE_ASSET';
export const UPLOAD_ASSETS_FILE = 'UPLOAD_ASSETS_FILE';
export const GET_ASSET_HISTORICS = 'GET_ASSETS_HISTORICS';
export const ACCEPT_ASSET_HISTORIC = 'ACCEPT_ASSET_HISTORIC';
export const REJECT_ASSET_HISTORIC = 'REJECT_ASSET_HISTORIC';
export const RESET_ASSET_HISTORICS_LIST = 'RESET_ASSET_HISTORICS_LIST';
export const SET_ASSET_HISTORICS_PAGINATION = 'SET_ASSET_HISTORIC_PAGINATION';
export const SET_ASSET_HISTORICS_FILTERS = 'SET_ASSET_HISTORIC_FILTERS';
export const MODIFY_FILE = 'MODIFY_FILE';
export const SEND_TOKEN_ASIGN = 'SEND_TOKEN_ASIGN';

export const OUTPUT_ASSET = 'OUTPUT_ASSET';
export const INPUT_ASSET = 'INPUT_ASSET';
export const ACEPT_OUTPUT = 'ACEPT_OUTPUT';
export const REJECT_OUTPUT = 'REJECT_OUTPUT';

export const GET_CODE_LABELS_BY_ASSET_PDF = 'GET_CODE_LABELS_BY_ASSET_PDF';
export const GET_QR_CODE_ASSET = 'GET_QR_CODE_ASSET';
export const REGENERATE_CODES_BY_ASSET_ID = 'REGENERATE_CODES_BY_ASSET_ID';
export const DOWNLOAD_FILE_AND_CONVERT_TO_BASE64 = 'DOWNLOAD_FILE_AND_CONVERT_TO_BASE64';

//Groups
export const MODIFY_CUSTOM_FIELD_EDITING_ASSET = 'MODIFY_CUSTOM_FIELD_EDITING_ASSET';



// WEBPACK FOOTER //
// src/containers/assets/constants.js